import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_BLUE,
    codeProp: 'ruleUserCode',
    mapProp: 'ruleMap',
    name: '界面规则',
    ownerIdProp: 'uiId',
    ownerTextProp: 'uiName',
    ownerType: 'UI',
    textProp: 'ruleTitle',
    type: 'UIRULE',
}
